// extracted by mini-css-extract-plugin
export var circle = "projects-module--circle--ANWDe";
export var descrtptionHeading = "projects-module--descrtptionHeading--QErZp";
export var fifth = "projects-module--fifth--dZyCF";
export var fifthEn = "projects-module--fifthEn--gc8N2";
export var first = "projects-module--first--mFJuL";
export var firstEn = "projects-module--firstEn--BXVuO";
export var fourth = "projects-module--fourth--HGQ5j";
export var fourthEn = "projects-module--fourthEn--hBLr2";
export var projectBblSpItem = "projects-module--projectBblSpItem--GLK1S";
export var projectImageContainer = "projects-module--projectImageContainer--BfW+h";
export var projectImageItem = "projects-module--projectImageItem--B9zqq";
export var projectSpContainer = "projects-module--projectSpContainer--bXUKm";
export var second = "projects-module--second--2-u5w";
export var secondEn = "projects-module--secondEn--tv3hS";
export var sixth = "projects-module--sixth--aba4w";
export var sixthEn = "projects-module--sixthEn--6EHcN";
export var third = "projects-module--third--4rM8Z";
export var thirdEn = "projects-module--thirdEn--sHrvy";
export var timeLine = "projects-module--timeLine--mLQWY";
export var timeLineContainer = "projects-module--timeLineContainer--f5BOZ";
export var timeLineDescription = "projects-module--timeLineDescription---+j23";
export var timeLineItem = "projects-module--timeLineItem--y0Hrq";
export var timeLineItemContainer = "projects-module--timeLineItemContainer--KoxDO";
export var timeLineStreakContainer = "projects-module--timeLineStreakContainer--7uh+i";
export var timeLineStreakItem = "projects-module--timeLineStreakItem--I1IQ3";
export var triangle = "projects-module--triangle--dO-PE";